const awsAuthConfig = {
  region: process.env.REACT_APP_REGION,
  identityPoolRegion: process.env.REACT_APP_REGION,
  identityPoolId: undefined,
  userPoolId: process.env.REACT_APP_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_CLIENT_ID,
  mandatorySignIn: false,
  authenticationFlowType: 'USER_SRP_AUTH',
  oauth: {
    domain: `cyberwire.auth.${process.env.REACT_APP_REGION}.amazoncognito.com`,
    scope: ['email', 'openid', 'profile'],
    redirectSignIn: `${process.env.REACT_APP_CMS_HOST}/login`,
    redirectSignOut: `${process.env.REACT_APP_CMS_HOST}/login`,
    responseType: 'code',
  },
}

export default awsAuthConfig
